var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLoadingSpinner(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    className: "loading-spinner",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.20001 6L3.24001 7.17796C3.65879 6.45061 4.17307 5.78449 4.77552 5.18204C5.66205 4.29551 6.69307 3.6 7.84164 3.1151C9.0294 2.61306 10.2906 2.35837 11.5935 2.35837C12.8963 2.35837 14.16 2.61306 15.3453 3.1151C16.4939 3.6 17.5249 4.29551 18.4114 5.18204C19.298 6.06857 19.9935 7.09959 20.4784 8.24816C20.9829 9.43347 21.2376 10.6971 21.2376 12C21.2376 13.3029 20.9829 14.5665 20.4808 15.7518C19.9959 16.9004 19.3004 17.9314 18.4139 18.818C17.5274 19.7045 16.4963 20.4 15.3478 20.8849C14.16 21.3869 12.8988 21.6416 11.5959 21.6416C10.7559 21.6416 9.92573 21.5339 9.12246 21.3233C8.34613 21.1176 7.5943 20.8139 6.89144 20.4196C5.50532 19.6433 4.31756 18.5241 3.46287 17.182C3.38695 17.062 3.31348 16.942 3.24246 16.8196L1.20001 18C1.28818 18.1543 1.38124 18.3037 1.4743 18.4531C3.60736 21.7886 7.34205 24 11.5935 24C18.2204 24 23.5935 18.6269 23.5935 12C23.5935 5.37306 18.2204 0 11.5935 0C7.15348 0 3.2743 2.41224 1.20001 6Z",
    fill: "#0028FC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoadingSpinner);
export default __webpack_public_path__ + "static/media/LoadingSpinner.8e0ee0d37ce398a863416b0d4b544ca1.svg";
export { ForwardRef as ReactComponent };